import React from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import FormaForm from '../Form';
import { createForm } from '@resources/Form/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createForm, visible, onCancel } = props;
	const intl = useIntl();
	const handleSubmit = (data) => {
		return createForm(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.page.create',
						defaultMessage:
							'A new Forma has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.form',
					defaultMessage: 'Create Form',
				})}
			</Title>
			<FormaForm onSubmit={handleSubmit} {...props} />
		</Modal>
	);
};

const mapStateToProps = ({ organization }) => {
	return {
		organization,
	};
};

export default connect(mapStateToProps, { createForm })(Create);
